module.exports = __webpack_public_path__ + "static/media/andrew.fa58fca7.jpg";